// extracted by mini-css-extract-plugin
export default {"menuList":"menu-dropdown_menuList__fwdaH","menuItem":"menu-dropdown_menuItem__ispaE"};